export const EStatusIcons = {
  OPEN: 'record',
  IN_PROGRESS: 'playArrow',
  TO_REVIEW: 'stop',
  ONHOLD: 'pause',
  CANCELLED: 'close',
  COMPLETED: 'check',
};
